import barba from "@barba/core";

class Single {
  constructor() {
    this.initTwitter();
    Single.initComments();
    Single.hideMouseForIframes();
  }

  static initComments() {
    // load wordpress comments
    if (barba.history.h.length > 1) {
      window.addComment.init();
    }
  }

  initTwitter() {
    this.twitterBlocks = window.wrapper.querySelectorAll('.twitter-tweet ~ script');
    if(this.twitterBlocks.length === 0){
      return;
    }

    if(window.twttr){
      this.initEmbedTweets();
    } else {
      Single.initTwitterScript();
    }
  }

  static initTwitterScript(){
    const _this = this;
    window.twttr = (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function(f) {
        t._e.push(f);
        _this.initEmbedTweets();
      };

      return t;
    }(document, "script", "twitter-wjs"));
  }

  initEmbedTweets() {
    if(this.twitterBlocks.length){
      window.twttr.widgets.load();
    }

    window.twttr.events.bind(
      'loaded',
      function (event) {
        event.widgets.forEach((widget) => {
          widget.addEventListener('mouseenter', () => window.cursor.enter(false, true));
          widget.addEventListener('mouseleave', () => window.cursor.leave());
        });
      }
    );
  }

  static hideMouseForIframes(){
    [].forEach.call(window.wrapper.querySelectorAll('iframe'), (iframe) => {
      iframe.addEventListener('mouseenter', () => window.cursor.enter(false, true));
      iframe.addEventListener('mouseleave', () => window.cursor.leave());
    });
  }
}

export default Single;
